import { useContext, useState } from 'react';
import { RootState } from '../../Redux/Store';
import { useAppSelector } from '../../Hooks/Hooks';
import { AppContext } from '../../Context/AppContext';
import { TLoadsContainerProps } from './LoadsContainer.type';
import { ELoadCardSize } from '../Shared/LoadCard/LoadCard.type';
import { EXECUTIONSTATUS, KEYS, MY_LOADS_PAGINATION } from '../../Constants/Constants';
import ShowMoreButton from '../Shared/ShowMoreButton/ShowMoreButton';
import LoadCard from '../Shared/LoadCard/LoadCard';
import ToggleSearchButton from '../Shared/ToggleSearchButton/ToggleSearchButton';
import './LoadsContainer.scss';

export const MocklistAndMapData = [
  {
    slug: 'list',
    title: 'List',
    imgSrc: '/oo/assets/icon/list-icon.svg',
    selected: true,
    visible: false,
  },
  {
    slug: 'map',
    title: 'Map',
    imgSrc: '/oo/assets/icon/map-icon.svg',
    selected: false,
    visible: false,
  },
];

const LoadsContainer = (props: TLoadsContainerProps) => {
  const {
    loads,
    label = 'Results',
    totalLoadsCount = 0,
    additionalClass,
    isMyLoads = false,
  } = props;

  const { isMobile } = useContext(AppContext);
  const { sortAndFilter } = useAppSelector((state: RootState) => state.search);
  const { myLoadsSortAndFilter } = useAppSelector((state: RootState) => state.myLoads);
  const [confirmedAppointments, setConfirmedAppointments] = useState(false);

  const handleShowMore = () => {};

  const handleClick = (id?: string) => {};

  const ToggleComponent = () => {
    return (
      <div className="Toggle_Container">
        <span>Confirmed Appointments Only</span>
        <ToggleSearchButton
          onToggle={() => setConfirmedAppointments(!confirmedAppointments)}
          value={confirmedAppointments}
        />
      </div>
    );
  };

  return (
    <div
      className={`LoadContainer ${additionalClass}`}
      data-testid="LoadContainer"
      id="LoadContainer"
    >
      <div className="Loads_Container_Header">
        {!isMobile && (
          <div className="Loads_Container_Heading">
            <p className="Heading">{label}</p>
          </div>
        )}

        <div className="Loads_Sort_Container">
          <p className="Total_Loads_Count">{totalLoadsCount} Assigned</p>

          {/* <SortingContainer
              showLabel={true}
              selectedValue={sortAndFilter?.sortColumn}
              sortDirection={sortAndFilter?.sortDirection}
              sortTypeOptions={filteredSortTypeOptions}
              handleSortDirectionChange={handleSortDirectionChange}
              handleSortType={(slug: string) => {
                // return dispatch(
                //   updateSortAndFilter({
                //     ...sortAndFilter,
                //     sortColumn: slug,
                //     page: 0,
                //   })
                // );
              }}
              modalSize="medium"
            /> */}
        </div>
        {isMobile && <ToggleComponent />}
      </div>
      <div>
        {!!(loads && loads?.length)
          ? loads?.map((item: any, index: number) => {
              const isRecentlyDeliveredLoad =
                item?.executionStatus === EXECUTIONSTATUS.COMPLETED ||
                item.executionStatus === EXECUTIONSTATUS.DELIVERED ||
                false;
              return (
                <LoadCard
                  key={item?.shipmentId}
                  data={item}
                  isMyLoads={true}
                  isRecentlyDelivered={isRecentlyDeliveredLoad}
                  showDropDown={true}
                  // handleRightTopButtonClick={handleRightTopButtonClick}
                  handleCardClick={(id?: string) => handleClick(id)}
                  showReload={true}
                  showRate={true}
                  showBottomButton={false}
                  size={isMobile ? ELoadCardSize.small : ELoadCardSize.large}
                  hideRightPart={false}
                />
              );
            })
          : null}
        <ShowMoreButton
          totalLoadCount={totalLoadsCount}
          pageNumber={isMyLoads ? myLoadsSortAndFilter?.page : sortAndFilter?.page}
          perPageMaxLoadCapacity={
            isMyLoads ? MY_LOADS_PAGINATION.PAGE_SIZE : KEYS?.RESULT_PER_PAGE_MAX_LOAD_CAPACITY
          }
          handleShowMore={handleShowMore}
        />
      </div>
    </div>
  );
};

export default LoadsContainer;
